import {
  Button, Card, CardContent, CardHeader, Paper,
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
  Select, MenuItem, FormControl, InputLabel, Box, Chip, Typography, TextField,
  Tooltip, IconButton, Dialog, DialogActions, DialogContent, DialogTitle
} from '@material-ui/core'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import React, { useState } from 'react'
import { useRecoilValue, useRecoilState, useSetRecoilState } from 'recoil'
import { logoSrc } from '../../api/logoSrc'
import { gregorianToJalali, toFarsiDigits } from '../../assets/utils'
import { departmentsState } from '../../pages/admin/atoms'
import api from '../../api/client';
import { beginImpersonation } from '../../api/impersonation';
import { exportExcel } from '../../assets/excelUtils';
import { userInfoState } from '../../recoil/atoms'
import UploadProgressInline from '../UploadProgressInline'
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import ExitToAppIcon from '@material-ui/icons/ExitToApp';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import ErrorOutlineIcon from '@material-ui/icons/ErrorOutline';
import StopIcon from '@material-ui/icons/Stop';
import { toast } from '../../api/toast';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: '#1a237e',
    color: theme.palette.common.white,
    fontWeight: 'bold',
    fontSize: 13,
    padding: '10px 8px',
    whiteSpace: 'nowrap',
    position: 'sticky',
    top: 0,
    zIndex: 2,
    borderLeft: '1px solid rgba(255,255,255,0.15)',
    '&:last-child': { borderLeft: 'none' },
  },
  body: {
    fontSize: 13,
    padding: '8px',
    borderBottom: '1px solid #e0e0e0',
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    transition: 'background-color 0.15s ease',
    '&:nth-of-type(odd)': {
      backgroundColor: '#f8f9ff',
    },
    '&:hover': {
      backgroundColor: '#e8eaf6 !important',
    },
  },
}))(TableRow);

const useStyles = makeStyles(theme => ({
  root: {
    background: '#fff',
    flexGrow: 1,
    marginBottom: theme.spacing(4),
    borderRadius: 12,
    overflow: 'hidden',
    boxShadow: '0 2px 12px rgba(0,0,0,0.08)',
  },
  header: {
    background: 'linear-gradient(135deg, #1a237e 0%, #283593 100%)',
    color: '#fff',
    padding: '16px 20px',
    '& .MuiCardHeader-title': {
      color: '#fff',
      fontWeight: 'bold',
      fontSize: 18,
    },
    '& .MuiCardHeader-action': {
      marginTop: 0,
      marginRight: 0,
    },
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(2),
    padding: '12px 20px',
    backgroundColor: '#f5f6fa',
    borderBottom: '1px solid #e0e0e0',
    direction: 'rtl',
  },
  filterControl: {
    minWidth: 180,
    '& .MuiOutlinedInput-root': {
      borderRadius: 8,
      backgroundColor: '#fff',
    },
    '& .MuiInputLabel-outlined': {
      fontFamily: 'inherit',
    },
  },
  addBtn: {
    borderRadius: 8,
    padding: '8px 20px',
    fontWeight: 'bold',
    backgroundColor: '#fff',
    color: '#1a237e',
    '&:hover': {
      backgroundColor: '#e8eaf6',
    },
  },
  tableContainer: {
    borderRadius: 0,
    boxShadow: 'none',
  },
  loginBtn: {
    borderRadius: 6,
    padding: '4px 14px',
    fontSize: 12,
    fontWeight: 'bold',
    textTransform: 'none',
    backgroundColor: '#1a237e',
    color: '#fff',
    '&:hover': {
      backgroundColor: '#283593',
    },
  },
  errorBtn: {
    borderRadius: 6,
    padding: '4px 14px',
    fontSize: 12,
    fontWeight: 'bold',
  },
  processingChip: {
    fontWeight: 'bold',
    fontSize: 12,
  },
  rowIndex: {
    fontWeight: 'bold',
    color: '#666',
    fontSize: 13,
    width: 40,
    minWidth: 40,
  },
  actionBtn: {
    padding: 6,
    transition: 'transform 0.15s ease',
    '&:hover': { transform: 'scale(1.15)' },
  },
  countBadge: {
    display: 'inline-flex',
    alignItems: 'center',
    gap: 6,
    color: 'rgba(255,255,255,0.85)',
    fontSize: 13,
    marginRight: theme.spacing(2),
  },
}))

const loginHandler = (id, setUserInfo, currentUser) => {
  // ذخیرهٔ نشست ادمین قبل از ورود جایگزین، تا «خروج» بعدی به همان صفحه برگرداند
  beginImpersonation(currentUser)
  api.post('users/login/' + id).then(result => {
    if (result.status === 200) {
      setUserInfo(result.data.user)
      localStorage.setItem('access', result.data.tokens.access)
      // مهم: توکن refresh هم باید توکن سازمان شود وگرنه رفرشِ بعدی
      // نشست را بلافاصله به ادمین برمیگرداند (باگ برگشت به پنل ادمین)
      if (result.data.tokens.refresh) {
        localStorage.setItem('refresh', result.data.tokens.refresh)
      }
      api.defaults.headers.common['Authorization'] = 'Bearer ' + result.data.tokens.access
    }
  })
}

const Departments = props => {
  const setUserInfo = useSetRecoilState(userInfoState)
  const [userInfo] = useRecoilState(userInfoState)
  const classes = useStyles()
  const departments = useRecoilValue(departmentsState)
  const { ordering, onOrderingChange } = props

  const [search, setSearch] = useState('')
  const [statusFilter, setStatusFilter] = useState('')
  const [confirmStop, setConfirmStop] = useState(null)   // id سازمان در حال توقف
  const [stopping, setStopping] = useState(false)

  const stopProcessing = async () => {
    if (!confirmStop || stopping) return
    setStopping(true)
    try {
      const r = await api.post(`contracts/upload-cancel/${confirmStop}/`)
      toast(r.data?.detail || 'درخواست توقف ثبت شد', 'success')
      setConfirmStop(null)
      // چند ثانیه بعد لیست بهروز شود (وضعیت برگشت به پیش از آپلود بهدست میآید)
      setTimeout(() => window.dispatchEvent(new CustomEvent('departments-refresh')), 4000)
      setTimeout(() => window.dispatchEvent(new CustomEvent('departments-refresh')), 10000)
    } catch (e) {
      toast((e && e.response && e.response.data && e.response.data.detail) || 'خطا در ثبت درخواست توقف', 'error')
    } finally {
      setStopping(false)
    }
  }

  // فیلتر سمت کلاینت (جستجو + وضعیت) — مرتب‌سازی از سرور می‌آید
  const filtered = departments.filter((d) => {
    const q = search.trim()
    const matchQ = !q
      || (d.name || '').includes(q)
      || (d.username || '').includes(q)
      || String(d.national_code || '').includes(q)
    if (!matchQ) return false
    if (statusFilter === 'processing') return !!d.is_processing
    if (statusFilter === 'with_login') return !!d.last_login && !d.is_processing
    if (statusFilter === 'no_login') return !d.last_login
    return true
  })

  return (
    <Card className={classes.root} style={{ direction: 'rtl' }} data-tour="admin-orgs">
      <CardHeader
        className={classes.header}
        title={
          <Box display="flex" alignItems="center">
            <span>سازمان‌ها</span>
            <Typography className={classes.countBadge} component="span">
              ({toFarsiDigits(departments.length)} سازمان)
            </Typography>
          </Box>
        }
        action={
          <Box style={{ display: 'flex', gap: 10, alignItems: 'center' }}>
            {filtered.length > 0 && (
              <Button
                variant='contained'
                className={classes.addBtn}
                onClick={() => exportExcel({
                  filename: 'departments.xlsx',
                  title: 'گزارش سازمان‌ها' + (search ? ` — فیلتر «${search}»` : '') + (statusFilter ? ` — وضعیت: ${statusFilter}` : ''),
                  headers: ['ردیف', 'نام سازمان', 'نام اختصاری', 'نام کاربری', 'شناسه ملی', 'آخرین بارگذاری موفق', 'آخرین آپلود ناموفق', 'وضعیت', 'آخرین ورود'],
                  rows: filtered.map((d, i) => [
                    i + 1,
                    d.name,
                    d.short_name || '',
                    d.username || '',
                    d.national_code ? toFarsiDigits(d.national_code) : '',
                    d.last_successful_upload ? gregorianToJalali(d.last_successful_upload) : '',
                    d.last_failed_upload ? gregorianToJalali(d.last_failed_upload) : '',
                    d.is_processing ? 'در حال پردازش' : 'عادی',
                    d.last_login ? gregorianToJalali(d.last_login) : '',
                  ]),
                })}
              >
                دانلود اکسل
              </Button>
            )}
            <Button
              variant='contained'
              className={classes.addBtn}
              startIcon={<AddIcon />}
              onClick={() => props.setOpenAddDepartment(true)}
            >
              افزودن سازمان
            </Button>
          </Box>
        }
      />

      <Box className={classes.toolbar}>
        <TextField
          variant="outlined"
          size="small"
          placeholder="🔍 نام سازمان، نام کاربری یا شناسه ملی..."
          value={search}
          onChange={(e) => setSearch(e.target.value)}
          className={classes.filterControl}
          style={{ minWidth: 260, background: '#fff', borderRadius: 8 }}
        />
        <FormControl variant="outlined" size="small" className={classes.filterControl}>
          <InputLabel>فیلتر وضعیت</InputLabel>
          <Select
            value={statusFilter}
            onChange={(e) => setStatusFilter(e.target.value)}
            label="فیلتر وضعیت"
          >
            <MenuItem value="">همه</MenuItem>
            <MenuItem value="with_login">دارای آخرین ورود</MenuItem>
            <MenuItem value="no_login">بدون آخرین ورود</MenuItem>
            <MenuItem value="processing">در حال پردازش</MenuItem>
          </Select>
        </FormControl>
        <FormControl variant="outlined" size="small" className={classes.filterControl}>
          <InputLabel>مرتب‌سازی</InputLabel>
          <Select
            value={ordering}
            onChange={(e) => onOrderingChange(e.target.value)}
            label="مرتب‌سازی"
          >
            <MenuItem value="last_upload">آخرین بارگذاری موفق</MenuItem>
            <MenuItem value="id">شماره (کد)</MenuItem>
            <MenuItem value="last_login">آخرین ورود</MenuItem>
          </Select>
        </FormControl>
      </Box>

      <CardContent style={{ padding: 0 }}>
        <TableContainer component={Paper} className={classes.tableContainer} style={{ overflowX: 'auto', }}>
          <Table size="small" style={{ direction: 'rtl' }}>
            <TableHead>
              <TableRow>
                <StyledTableCell align='center' style={{ width: 40 }}>لوگو</StyledTableCell>
                <StyledTableCell align='center' style={{ width: 40 }}>ردیف</StyledTableCell>
                <StyledTableCell align='center'>کد</StyledTableCell>
                <StyledTableCell align='center'>نام کاربری</StyledTableCell>
                <StyledTableCell align='center' style={{ textAlign: 'right' }}>عنوان</StyledTableCell>
                <StyledTableCell align='center'>شناسه ملی</StyledTableCell>
                <StyledTableCell align='center'>آخرین بارگذاری موفق</StyledTableCell>
                <StyledTableCell align='center'>آخرین ورود</StyledTableCell>
                <StyledTableCell align='center'>وضعیت</StyledTableCell>
                <StyledTableCell align='center'>آخرین بارگذاری ناموفق</StyledTableCell>
                <StyledTableCell align='center'>خطا</StyledTableCell>
                <StyledTableCell align='center'>ورود</StyledTableCell>
                <StyledTableCell align='center' style={{ width: 90 }}>عملیات</StyledTableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filtered.map((row, index) => (
                <StyledTableRow key={row.id}>
                  <StyledTableCell align='center'>
                    {row.logo ? (
                      <img
                        src={logoSrc(row.logo)}
                        alt=""
                        style={{ width: 34, height: 34, borderRadius: '50%', objectFit: 'cover', border: '1.5px solid #e3e6f2' }}
                        onError={(e) => { e.target.style.display = 'none' }}
                      />
                    ) : (
                      <span style={{ color: '#bbb' }}>—</span>
                    )}
                  </StyledTableCell>
                  <StyledTableCell align='center' className={classes.rowIndex}>
                    {toFarsiDigits(index + 1)}
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    {toFarsiDigits(row.id)}
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    {toFarsiDigits(row.username)}
                  </StyledTableCell>
                  <StyledTableCell align='right' style={{ textAlign: 'right', fontWeight: 'bold' }}>
                    {toFarsiDigits(row.short_name || row.display_name || row.name)}
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    {toFarsiDigits(row.national_code)}
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    {row.last_successful_upload ? (
                      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2 }}>
                        <Chip
                          size="small"
                          icon={<CheckCircleIcon style={{ color: '#2e7d32', fontSize: 16 }} />}
                          label={gregorianToJalali(row.last_successful_upload)}
                          style={{ backgroundColor: '#e8f5e9', color: '#2e7d32', fontSize: 12, fontWeight: 'bold' }}
                        />
                        {row.last_source_code ? (
                          <span style={{ fontSize: 10.5, color: '#475569', fontWeight: 600 }}>
                            جام: {toFarsiDigits(row.last_source_code)}
                            {row.last_source_name ? ` — ${row.last_source_name}` : ''}
                            {row.last_source_user ? ` (${row.last_source_user})` : ''}
                          </span>
                        ) : null}
                      </div>
                    ) : (
                      <Typography variant="caption" color="textSecondary">—</Typography>
                    )}
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    {row.last_login ? (
                      <span style={{
                        fontSize: 11.5,
                        background: '#f3e5f5',
                        color: '#7b1fa2',
                        borderRadius: 8,
                        padding: '3px 8px',
                        fontWeight: 700,
                        whiteSpace: 'nowrap',
                      }}>{gregorianToJalali(row.last_login)}</span>
                    ) : (
                      <Typography variant="caption" color="textSecondary">—</Typography>
                    )}
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    {row.is_processing ? (
                      <>
                        <Chip size="small" label="در حال پردازش"
                          className={classes.processingChip}
                          style={{ backgroundColor: '#e3f2fd', color: '#1565c0', fontWeight: 700 }} />
                        <UploadProgressInline deptId={row.id} isProcessing={row.is_processing} />
                      </>
                    ) : row.last_login ? (
                      <Chip size="small" label="فعال"
                        className={classes.processingChip}
                        style={{ backgroundColor: '#e8f5e9', color: '#2e7d32', fontWeight: 700 }} />
                    ) : (
                      <Chip size="small" label="بدون ورود"
                        className={classes.processingChip}
                        style={{ backgroundColor: '#eceff1', color: '#607d8b', fontWeight: 700 }} />
                    )}
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    {row.last_failed_upload ? (
                      <Chip
                        size="small"
                        icon={<CancelIcon style={{ color: '#c62828', fontSize: 16 }} />}
                        label={gregorianToJalali(row.last_failed_upload)}
                        style={{ backgroundColor: '#ffebee', color: '#c62828', fontSize: 12 }}
                      />
                    ) : (
                      <Typography variant="caption" color="textSecondary">—</Typography>
                    )}
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    {row.process_error ? (
                      <Tooltip title={row.process_error} arrow placement="top">
                        <IconButton size="small" style={{ color: '#c62828' }}>
                          <ErrorOutlineIcon fontSize="small" />
                        </IconButton>
                      </Tooltip>
                    ) : (
                      <Typography variant="caption" color="textSecondary">—</Typography>
                    )}
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    <Button
                      variant='contained'
                      className={classes.loginBtn}
                      startIcon={<ExitToAppIcon style={{ fontSize: 16 }} />}
                      onClick={() => loginHandler(row.id, setUserInfo, userInfo)}
                      size="small"
                    >
                      ورود
                    </Button>
                  </StyledTableCell>
                  <StyledTableCell align='center'>
                    <Box display="flex" justifyContent="center" gap={1}>
                      {row.is_processing && (
                        <Tooltip title="توقف پردازش آپلود" arrow>
                          <IconButton
                            className={classes.actionBtn}
                            style={{ backgroundColor: '#fff3e0', borderRadius: 8 }}
                            onClick={() => setConfirmStop(row.id)}
                            size="small"
                          >
                            <StopIcon style={{ color: '#e65100', fontSize: 20 }} />
                          </IconButton>
                        </Tooltip>
                      )}
                      <Tooltip title="ویرایش" arrow>
                        <IconButton
                          className={classes.actionBtn}
                          style={{ backgroundColor: '#e3f2fd', borderRadius: 8 }}
                          onClick={() => props.setOpenEditDepartment(row.id)}
                          size="small"
                        >
                          <EditIcon style={{ color: '#1565c0', fontSize: 20 }} />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="حذف" arrow>
                        <IconButton
                          className={classes.actionBtn}
                          style={{ backgroundColor: '#ffebee', borderRadius: 8 }}
                          onClick={() => props.setOpenDeleteDepartment(row.id)}
                          size="small"
                        >
                          <DeleteIcon style={{ color: '#c62828', fontSize: 20 }} />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </StyledTableCell>
                </StyledTableRow>
              ))}
              {filtered.length > 0 && (
                <StyledTableRow>
                  <StyledTableCell colSpan={13} align='center' style={{
                    background: '#f5f6fb',
                    color: '#7b84b8',
                    fontWeight: 700,
                    fontSize: 13,
                    padding: 10,
                    borderTop: '2px dashed #d5daf3',
                  }}>
                    ✓ پایان لیست — {toFarsiDigits(filtered.length)} مورد
                  </StyledTableCell>
                </StyledTableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <Dialog open={!!confirmStop} onClose={() => { if (!stopping) setConfirmStop(null) }} maxWidth="sm" fullWidth>
          <DialogTitle style={{ color: '#b71c1c', fontWeight: 'bold' }}>
            توقف پردازش آپلود
          </DialogTitle>
          <DialogContent dividers>
            <Typography variant="body2" style={{ lineHeight: 2.3 }}>
              توجه — با توقف پردازش:
              <br />۱) <b>کل پردازش جاری به عقب برمیگردد</b> و دیتابیس دقیقاً در وضعیت پیش از آپلود قرار میگیرد (هیچ رکوردی از همین فایل نمیماند).
              <br />۲) سازمان فوراً میتواند فایل را دوباره آپلود کند.
              <br />۳) توقف در گزارش آپلود (UploadRun) ثبت میشود؛ نیازی به تکرار درخواست نیست.
              <br />۴) اگر پردازش پیش از توقف به پایان رسیده باشد، امکان توقف وجود ندارد و پیام میدهد.
            </Typography>
          </DialogContent>
          <DialogActions style={{ padding: '8px 16px 14px' }}>
            <Button disabled={stopping} onClick={() => setConfirmStop(null)} color="default" style={{ fontWeight: 'bold' }}>
              انصراف
            </Button>
            <Button disabled={stopping} onClick={stopProcessing} variant="contained" style={{ backgroundColor: '#c62828', color: '#fff', fontWeight: 'bold' }}>
              {stopping ? 'در حال ثبت...' : 'توقف پردازش'}
            </Button>
          </DialogActions>
        </Dialog>
      </CardContent>
    </Card>
  )
}

export default Departments
